import { Config, Scene, Cameras, ItemManager, events, Develop, defines, Renderer, Camera, DefaultCamera, CameraControlType, CameraControl, OrbitCameraControl } from "./index";

/* ThreeViewBase
 * 3Dビュークラス.
 */
export class ThreeViewBase {
    protected static _instance: ThreeViewBase;
    static get(container?: HTMLElement, params?: {}): ThreeViewBase {
        if (ThreeViewBase._instance === undefined) {
            new ThreeViewBase(container, params);
        }
        return ThreeViewBase._instance;
    }

    public get container(): HTMLElement { return this._container; }
    public get renderer(): Renderer { return this._renderer; }
    public get scene(): Scene { return this._scene; }
    public get cameras(): Cameras { return this._cameras; }
    public get itemmgr(): ItemManager { return this._itemmgr; }
    public get eventDispatcher(): events.EventDispatcher { return this._orgEventDispatcher; }
    public get develop(): Develop { return this._develop; } // 開発用
    public get visible(): boolean { return this.container != undefined; }

    protected _container: HTMLElement;
    private _renderer: Renderer;
    private _scene: Scene;
    private _cameras: Cameras;
    private _itemmgr: ItemManager;
    private _orgEventDispatcher: events.EventDispatcher;
    protected _develop: Develop; // 開発用

    private _params: any;
    public get params() { return this._params; }                                                                                // ---- unuseed -------
    public hasParam(name: string): boolean { return this._params == undefined ? false : this._params[name] != undefined; }
    public getParam(name: string): any { return this._params[name]; }                                                           // ---- unuseed -------

    constructor(container?: HTMLElement, params?: any) {
        ThreeViewBase._instance = this;

        // コンテナをセット
        if (container === null) container = document.getElementById('webcad3dView');
        this._container = container;
        this._orgEventDispatcher = new events.EventDispatcher;

        // 初期化.
        this._params = params;
        this.initialize();

        // イベントハンドラの登録(継承クラスの初期化前提のためinitializeの外に置く.)
        this.registerHandlers();
    }

    /* initialize
    * 初期化.
    */
    protected initialize(): void {
        this.setupScene();              // シーンを作成.
        this.setupItemManager();        // アイテム管理を作成.
        this.setupCameras();            // カメラ管理を作成.
        this.setupMisc();               // その他を作成
        this.setupRenderer();           // レンダラーを作成.
        this._startRendering();        // レンダリングを開始.
    }

    /* reset
    * 内容をリセット.
    */
    public reset(options: defines.Options): void {
        this.renderer.reset(options);
        this.scene.reset(options);
        this.cameras.reset(options);
        this.itemmgr.reset(options);
    }

    /* setupScene
    * シーンの準備.
    */
    protected setupScene(): void {
        this._scene = this.createScene();
    }

    /* createScene
    * シーンの準備.
    */
    protected createScene(): Scene {
        return new Scene();
    }

    /* setupItemManager
    * アイテムの管理の準備.
    */
    protected setupItemManager(): void {
        this._itemmgr = this.createItemManager(this.scene, this.eventDispatcher);
    }

    /* createItemManager
    * アイテムの管理の作成.
    */
    protected createItemManager(scene: Scene, eventDispatcher: events.EventDispatcher): ItemManager {
        return new ItemManager(scene, eventDispatcher);
    }

    /* setupRenderer
    * レンダラ関連の準備.
    */
    protected setupRenderer(): void {
        this._renderer = this.createRenderer(this.container);
        this._renderer.set_cameras(this.cameras);
        this._renderer.set_items(this.itemmgr);
    }

    /* createRenderer
    * レンダラの作成.
    */
    protected createRenderer(container: HTMLElement): Renderer {
        return new Renderer(container, {});
    }

    /* setupCameras
    * カメラ関連のセットアップ
    */
    protected setupCameras(): void {
        this._cameras = this.createCameraManager(this.eventDispatcher);
        this.createCameras();
    }

    /* createCameraManager
    * カメラコントロールの作成.
    */
    protected createCameraManager(eventDispatcher: events.EventDispatcher): Cameras {
        return new Cameras(eventDispatcher);
    }

    /* createCameras
    * カメラコントロールの作成.
    */
    public createCameras(): void {
        let cam: Camera = new DefaultCamera();
        cam.control = this.createCameraControl(cam);
        this.cameras.add(cam, true);
    }

    /* setupMisc
    * その他のセットアップ
    */
    protected setupMisc() {
        /* to be overridden */
    }

    /* registerHandlers
    * イベントハンドラの登録.
    */
    protected registerHandlers(): void {
        // リサイズ時のイベントハンドラ.
        window.addEventListener('resize', this.windowResized);
        this.cameras.eventDispatcher.addEventListener(defines.EventNames.cameraChanged, this.cameraChanged);
    }

    windowResized = () => {
        this.renderer.canvasSizeChanged();
        this.cameras.canvasSizeChanged();
        this.onScreenSizeChange();
    }

    onScreenSizeChange =()=>{};

    cameraChanged = () => {
        //console.log("Camera changed!");
        this.updateView();
    }

    /* createCameraControl
    * カメラコントロールの作成.
    */
    public createCameraControl(camera: Camera, controlType?: CameraControlType): CameraControl {
        return new OrbitCameraControl(camera, this.container);
    }

    /* _startRendering
    * レンダリングを開始.
    */
    protected _startRendering(): void {
        // if (this.cameras.camera != undefined) {
        //         this.renderer.animation(this.scene, this.cameras.camera);
        //         this.updateView();
        // }
        if (this.cameras.camera == undefined) return;
        this.renderer.animation(this.scene, this.cameras.camera);
        this.updateView();
    }

    /* updateView
    * 再表示.
    */
    public updateView(): void {
        if ((this.scene.me == undefined) || (this.cameras.camera == undefined)) return;
        this.scene.me.updateMatrix();
        this.renderer.me.clear();
        this.renderer.render(this.scene, this.cameras.camera);
    }
}
